// extracted by mini-css-extract-plugin
module.exports = {"container":"JobSnippet_container__pm54_","title":"JobSnippet_title__W4wkR"};